import { Box, Typography, Stack } from '@mui/material';
import StockAllowance from '../../components/StockAllowance';
import { AddProcedureStockAllowanceType } from '../entity';

type ProcedureCardContentProps = {
  stockAllowances: AddProcedureStockAllowanceType;
  description?: string;
};

const ProcedureCardContent = ({ description, stockAllowances }: ProcedureCardContentProps) => (
  <Box
    sx={{
      flexGrow: 1,
      padding: '1rem',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-start',
    }}
  >
    {description && (
      <Typography variant="body1" sx={{ marginBottom: 1 }}>
        {description}
      </Typography>
    )}

    <Stack
      direction="row"
      rowGap={2}
      columnGap={1}
      alignItems="center"
      flexWrap="wrap"
      justifyContent="flex-end"
    >
      {stockAllowances.map(stockAllowance => (
        <StockAllowance
          id={stockAllowance.stockAllowanceId}
          name={stockAllowance.stockItemName || ''}
          quantity={stockAllowance.quantity}
          key={stockAllowance.stockAllowanceId}
        />
      ))}
    </Stack>
  </Box>
);
export default ProcedureCardContent;
